import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MedicalServiceWizardService } from '../../../services/wizard/medical-service/medical-service-wizard';
import { MedicalServiceCareComponent } from '../medical-service-care/medical-service-care.component';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { MedicalServiceConsultationHistoryComponent } from '../medical-service-consultation-history/medical-service-consultation-history.component';
import { ConfirmDialogService } from '../../../services/confirm-dialog.service';
import { StudyReportWizardService } from 'src/app/services/wizard/study-report/study-report.wizard.service';
import { StudyReportWizardFactory } from '../../../factory/study-report-wizard.factory';
import { Router } from '@angular/router';
import { StudyReportService } from '../../../services/study-report/study-report.service';
import { VideoChatService } from '../../../services/video-chat/video-chat.service';
import { VideoChatRequest } from '../../../model/video-chat/video-chat-request';
import { VideoChatAlertService } from '../../../services/video-chat/video-chat-alert.service';
import { AuthService } from '../../../services/auth.service';
import { MatDialog } from '@angular/material';
import { MedicalAppointmenObservationDialogComponent } from '../../dialogs/medical-appointment-observation/medical-appointment-observation-dialog.component';

@Component({
  selector: 'app-medical-service-wizard',
  templateUrl: './medical-service-wizard.component.html',
  styleUrls: ['./medical-service-wizard.component.css']
})
export class MedicalServiceWizardComponent implements OnInit, OnDestroy {

  @ViewChild('medicalServiceCareComponent', {static: false}) medicalServiceCareComponent: MedicalServiceCareComponent;
  @ViewChild('medicalServiceConsultationHistoryComponent', {static: false}) medicalServiceConsultationHistoryComponent: MedicalServiceConsultationHistoryComponent;
  medicalorderId: number;
  loadingAction: boolean;
  loading: boolean;
  medicalAppointmentId: number;
  patientId: number;
  calling: boolean;
  videoChatVisible: boolean;
  enabledVideoChat: boolean;
  noConnection: boolean;
  canViewReferringPhysician: boolean;
  onlyViewHc: boolean;
  canViewStudyReportRegion: boolean;

  win: any;
  tabIndex: number;

  constructor(
      private medicalServiceWizardService: MedicalServiceWizardService,
      public dialog: MatDialog,
      private router: Router,
      private authService: AuthService,
      private studyReportWizardService: StudyReportWizardService,
      private studyReportWizardFactory: StudyReportWizardFactory,
      private confirmDialogService: ConfirmDialogService,
      private videoChatAlertService: VideoChatAlertService,
      private studyReportService: StudyReportService,
      private notificationToastService: NotificationToastService) {

    this.medicalorderId = this.medicalServiceWizardService.medicalServiceSearchItem.MedicalOrderId;
    this.medicalAppointmentId = this.medicalServiceWizardService.medicalServiceSearchItem.MedicalAppointmentId;
    this.patientId = this.medicalServiceWizardService.medicalServiceSearchItem.PatientId;
  }

  async ngOnInit()  {
    await this.setEnableVideoChatIfRequired();
    this.canViewReferringPhysician = await this.authService.canViewReferringPhysician();
    this.canViewStudyReportRegion = await this.authService.canViewStudyReportRegion();
    this.onlyViewHc =  await this.authService.OnlyViewHc();
    setTimeout(() => {
      if (this.onlyViewHc) {
        this.tabIndex = 1;
      }
    }, 500);

  }

  openMedicalAppointmentObservationDialog(): void {
    const dialogRef = this.dialog.open(MedicalAppointmenObservationDialogComponent, {
      width: '50%',
      data: { medicalAppointmentId: this.medicalAppointmentId }
    });
  }


  private async setEnableVideoChatIfRequired() {

    const info = await this.medicalServiceWizardService.getMedicalAppointmentCareEditInfo();
    this.enabledVideoChat = info.EnabledVideoChat;
    if (this.enabledVideoChat) {
      this.calling = true;
      this.videoChatAlertService.setOnVideoChat( this.patientId );
    }
    setTimeout(() => {
      this.tabIndex  = 0;
    });
  }

  onConnectionClosed() {

    this.videoChatVisible = false;
    this.calling = true;
  }

  async startVideoChat() {
    this.videoChatAlertService.startVideoChat( );
  }

  get isViewMode(): boolean {
    return this.medicalServiceWizardService.view;
  }

  async finalizeMedicalAppointmentCare() {
    try {
      this.loadingAction = true;

      this.medicalServiceCareComponent.save();
      let careComplete = this.medicalServiceCareComponent.completed;


      if (careComplete && this.medicalServiceConsultationHistoryComponent.completed) {
        const lockInfo = await this.medicalServiceWizardService.finalizeMedicalAppointmentCare();

        if (lockInfo == null || (lockInfo.IsLock && !lockInfo.AutoLock)) {
          this.notificationToastService.success('Se ha finalizado la atención correctamente', 'Atención de turno');
          if (lockInfo != null) {
            this.notificationToastService.error('El informe se encuentra bloqueado por el usuario '
            + lockInfo.UserLock, 'Informe bloqueado');
          }
          this.cancel();
        } else if (!lockInfo.IsLock || lockInfo.AutoLock) {
          this.confirmDialogService.confirm('Informar', 'Desea informar el estudio?', 'Si', 'No')
              .subscribe(value => {
                  if (value) {
                    this.studyReportWizardService.initialize(
                      this.studyReportWizardFactory.CreateStudyReportWizard(lockInfo.StudyReportSearchItem, false));
                    this.router.navigate(['/study-report-wizard', '/medical-service-search']);
                  } else {
                    this.studyReportService
                      .studyReportUnlock(lockInfo.StudyReportSearchItem.StudyReportId).then(() => {
                        this.cancel();
                    });
                  }
              });
        }
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Atención de turno');
    } finally {
      this.loadingAction = false;
    }
  }

  onReAppointmentChange() {
      this.cancel();
  }

  async keepMedicalAppointmentCare() {

    try {
      this.loadingAction = true;
      this.medicalServiceCareComponent.save();
      if (this.medicalServiceCareComponent.completed) {
        await this.medicalServiceWizardService.keepMedicalAppointmentCare();
        this.cancel();
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Atención de turno');
    } finally {
      this.loadingAction = false;
    }
  }

  cancel(): void {
    history.back();
  }

  ngOnDestroy(): void {

    this.videoChatAlertService.setOffVideoChat( );
    this.videoChatAlertService.closeWin();
  }
}
